import DatePickerRenderView from './DatePicker';
import RecaptchView from './RecaptchaView';
import TextRenderView from './Text';

const renderViews = {
  text: TextRenderView,
  recaptcha: RecaptchView,
  datetimepicker: DatePickerRenderView,
};

export default renderViews;
